module.exports = __webpack_public_path__ + "static/media/woosik.e4a4961b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/about/woosik.jpg
// module id = 156
// module chunks = 0